/**
 * @fileoverview ModalHeader component for the metadata edit modal.
 * Displays the category title in the modal header section.
 */

/**
 * Props for the ModalHeader component.
 */
interface ModalHeaderProps {
  /** Title to display in the header (typically the German category label) */
  readonly title: string;
}

/**
 * ModalHeader displays the category title at the top of the edit modal.
 * Provides consistent styling and layout for the modal header section.
 *
 * @param props - Component props
 * @returns Modal header UI
 */
export default function ModalHeader({ title }: ModalHeaderProps) {
  return (
    <div className="px-6 py-6 border-b border-[#e4e4e7]">
      <h2 className="text-2xl font-semibold text-[#18181b] leading-8">
        {title}
      </h2>
    </div>
  );
}
